import { render, staticRenderFns } from "./DocumentRequestConfirm.vue?vue&type=template&id=33ef02f9&scoped=true&"
import script from "./DocumentRequestConfirm.vue?vue&type=script&lang=js&"
export * from "./DocumentRequestConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequestConfirm.vue?vue&type=style&index=0&id=33ef02f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef02f9",
  null
  
)

export default component.exports